import { render, staticRenderFns } from "./FieldCheckbox.vue?vue&type=template&id=58806132&scoped=true&"
import script from "./FieldCheckbox.vue?vue&type=script&lang=js&"
export * from "./FieldCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./FieldCheckbox.vue?vue&type=style&index=0&id=58806132&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58806132",
  null
  
)

export default component.exports